export interface GoToMapTarget {
  resourceId: string;
  officeId: string;
  /** Day (`yyyy-MM-dd`) or full ISO date-time the map should open on. */
  date: string;
  floorId: string | null;
}

/**
 * Reads the legacy `#goToMap=true&resource=…&office=…&date=…&floor=…` fragment.
 *
 * Email, Slack and Teams notifications sent before the move to `/map?…` links
 * still point at `/dashboard` with this fragment, so the dashboard keeps
 * honouring it. Returns `null` when the fragment is absent or misses one of the
 * parts needed to locate the resource.
 */
export const parseGoToMapHash = (hash: string): GoToMapTarget | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  if (!params.get("goToMap")) {
    return null;
  }

  const resourceId = params.get("resource");
  const officeId = params.get("office");
  const date = params.get("date");
  if (!resourceId || !officeId || !date) {
    return null;
  }

  return { resourceId, officeId, date, floorId: params.get("floor") };
};
